// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    line-height: 1.6;
}

.about-title {
    margin-bottom: 1.5rem;
    text-align: center;
}

.about-text {
    margin-bottom: 1.25rem;    
}

.about-version {
    margin-top: 2rem;
    font-size: 1.1rem;
    text-align: center;    
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/AboutPage.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.about-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 2rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.about-title {\r\n    margin-bottom: 1.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.about-text {\r\n    margin-bottom: 1.25rem;    \r\n}\r\n\r\n.about-version {\r\n    margin-top: 2rem;\r\n    font-size: 1.1rem;\r\n    text-align: center;    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
